/**
 * The signed-in user's rights on one site (ORIENTATION-ROLES P2): the WorkOS
 * tier from the JWT plus their own `my_user_sites` and `my_site_rights` rows.
 * Rules in lib/siteAccess. `isReady` once both rows have loaded.
 */
import { useMemo } from 'react';
import { useTable } from 'spacetimedb/react';
import { tables as minetwinTables } from '@sdk/minetwin';
import { useRole } from '@/hooks/useRole';
import { siteAccessFor, type SiteAccess } from '@/lib/siteAccess';

export function useSiteAccess(projectId: string): SiteAccess & { isReady: boolean } {
  const role = useRole();
  const [mySites, sitesReady] = useTable('minetwin', minetwinTables.my_user_sites);
  const [myRights, rightsReady] = useTable('minetwin', minetwinTables.my_site_rights);
  return useMemo(
    () => ({
      ...siteAccessFor(role, projectId, mySites, myRights),
      isReady: sitesReady && rightsReady,
    }),
    [role, projectId, mySites, myRights, sitesReady, rightsReady],
  );
}
